import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DrawoutTestSpaceService } from '../../services/drawout-test-space.service';

@Injectable({
  providedIn: 'root'
})
export class TestSpaceServiceLoadResolver  {

  constructor(private tsService: DrawoutTestSpaceService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> {
    this.tsService.startService();
    this.tsService.loadTestspaces();
    this.tsService.loadOrganisations();

    return of(true);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ResetTSService  {

  constructor(private tsService: DrawoutTestSpaceService) {}

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.tsService.reset();
    return true;
  }
}
